import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-79ff2a12"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "not-found glass-panel"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "code"
}, "404", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "页面不存在", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前地址没有对应页面。", -1));
const _hoisted_5 = {
  class: "actions"
};
export default {
  __name: 'NotFound',
  setup(__props) {
    const goHome = () => {
      window.location.hash = "#/";
    };
    const goLogin = () => {
      window.location.hash = "#/login";
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: goHome
      }, {
        default: _withCtx(() => [_createTextVNode("回到主页")]),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: goLogin
      }, {
        default: _withCtx(() => [_createTextVNode("去登录")]),
        _: 1
      })])]);
    };
  }
};